module.exports = __webpack_public_path__ + "static/media/pato_branco.19463cce.png";